import cloneDeep from 'lodash/cloneDeep';

export interface License {
    id: number;
    name: string;
    licenseId: number;
    price: number;
    surveyCount: number;
    userCount: number;
    storageCount: number;
    durationType: 'Y' | 'D'; // year/day
    duration: number; // days
    parentId: number;
}

export const initialLicense: Readonly<License> = {
    id: 0,
    licenseId: -1,
    name: '',
    price: 0,
    surveyCount: 0,
    userCount: 0,
    storageCount: 0,
    durationType: 'D',
    duration: 0,
    parentId: 0,
};

export const mapLicense = ({
    DURATION_TYPE,
    ID,
    LICENSE_ID,
    NAME,
    PARENT_ID,
    PRICE,
    QNT_DURATION,
    QNT_SURVEY,
    QNT_USER,
    QNT_VALUE,
}: any): Partial<License> => ({
    ...cloneDeep(initialLicense),
    id: ID,
    licenseId: LICENSE_ID,
    name: NAME,
    price: PRICE,
    surveyCount: QNT_SURVEY,
    userCount: QNT_USER,
    storageCount: QNT_VALUE,
    durationType: DURATION_TYPE,
    duration: QNT_DURATION,
    parentId: PARENT_ID,
});
